<div class="container" *ngIf="!loading">
    <div class="row">
        <div class="col-sm-12">
            <h4>Interessen</h4>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-3">
            <form class="example-form">
                <mat-form-field class="full-width" appearance="fill">
                    <mat-label>Suche</mat-label>
                    <input matInput [formControl]="this.filterForm.controls.searchTerm" placeholder="suchen.."
                        (keydown)="onKeydown($event)">
                </mat-form-field>
            </form>
        </div>
        <div class="col-sm-3 desktopFilter">
            <div class="centerAndJustify">
                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Status</mat-label>
                    <mat-select [formControl]="this.filterForm.controls.filterState">
                        <mat-select-trigger>
                            <span *ngIf="this.filterForm.controls.filterState.value != null ">
                                {{this.filterForm.controls.filterState.value | translateFilterInterest : 'filterState'}}
                            </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let sortOption of sortOptionsState" [value]="sortOption.value">
                            {{sortOption.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="row marginBottom2Rem">
        <div class="col-sm-12">
            <button mat-button mat-raised-button color="accent" (click)="filterInterests()"
                [disabled]="!this.filterForm.touched">
                Anwenden
            </button>
            <button mat-button mat-raised-button color="primary" (click)="resetFilter()" style="margin-left: 15px;"
                [disabled]="!this.filterForm.touched">
                Filter zurücksetzen
            </button>
        </div>
    </div>


    <!-- <div class="row">
        <div class="col-sm-12">
            <div class="example-container mat-elevation-z2">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
                            {{i+1}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>
                            Bezeichnung
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column" style="padding-right: 25px;">
                            {{element.name}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="state">
                        <th mat-header-cell *matHeaderCellDef>
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            <mat-chip-set>
                                <mat-chip class="primaryChip" selected *ngIf="element.state == 'ACTIVE'">
                                    {{element.state | translateState }}</mat-chip>
                            </mat-chip-set>

                            <mat-chip disabled *ngIf="element.state == 'DELETED'">
                                {{element.state | translateState }}</mat-chip>

                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>
                            Aktion
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                color="accent">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item [routerLink]="['edit', element.publicId]"
                                    [state]="{interest : element}">
                                    <span>Bearbeiten</span>
                                </button>
                                <button mat-menu-item (click)="delteInterest(element)">
                                    <span>Löschen</span>
                                </button>

                            </mat-menu>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index">
                    </tr>
                </table>
                <span *ngIf="this.dataSource?.filteredData.length == 0" class="emptyTableState">
                    Keine passenden Einträge gefunden
                </span>
            </div>
            <button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['add']">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div> -->

    <div class="row marginTop2Rem marginBottom2Rem">
        <div class="col-sm-12">
            <mat-card appearance="outlined" class="example-card">
                <mat-card-content>

                    <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
                        <div class="example-box" *ngFor="let element of positions;let i = index" cdkDrag>
                            <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                            <span style="width: 90%;display: flex;justify-content: space-between;align-items: center;">
                                <span style="width: 5;">
                                    {{i+1}}
                                </span>
                                <span style="width: 75%;">
                                    {{element.name}}
                                </span>

                                <mat-chip-set style="width: 10%;">
                                    <mat-chip class="primaryChip" selected>{{element.state |
                                        translateState}}</mat-chip>
                                </mat-chip-set>
                            </span>
                            <button mat-icon-button style="margin: 0 auto !important;" (click)="moveOnePositionUP(i)">
                                <mat-icon> keyboard_arrow_up </mat-icon>
                            </button>

                            <button mat-icon-button style="margin: 0 auto !important;" (click)="moveOnePositionDown(i)">
                                <mat-icon>keyboard_arrow_down</mat-icon>
                            </button>

                            <button mat-icon-button style="margin: 0 auto !important;" (click)="moveOnePositionTop(i)">
                                <mat-icon class="rotate90Deg">first_page</mat-icon>
                            </button>
                            <button mat-icon-button style="margin: 0 auto !important;" (click)="moveOnePositionLast(i)">
                                <mat-icon class="rotate90Deg">last_page</mat-icon>
                            </button>

                            <ng-container>
                                    <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                        color="accent" >
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item [routerLink]="['edit', element.publicId]"
                                            [state]="{interest : element}">
                                            <span>Bearbeiten</span>
                                        </button>
                                        <button mat-menu-item (click)="delteInterest(element)">
                                            <span>Löschen</span>
                                        </button>
        
                                    </mat-menu>
                            </ng-container>

                        </div>
                    </div>

                </mat-card-content>
                <mat-card-actions align="end">
                    <button mat-button color="primary" (click)="saveChanges()">Änderungen speichern</button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>

</div>

<div class="container" *ngIf="loading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>